import { render } from "./Journeys.vue?vue&type=template&id=0ff9c089&ts=true"
import script from "./Journeys.vue?vue&type=script&lang=ts"
export * from "./Journeys.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__